import { getLocal, setLocal } from '@laigu/utils/storage';
import { getMarkKey } from '@/utils';

const localKey = 'conversationUnread';
export const getLocalUnreadData = () => {
  const agentMarkData = getLocal(localKey) || {};
  let data = [];
  if (agentMarkData) {
    data = agentMarkData[getMarkKey()] || {};
  }
  return data;
};

const sliceObject = (obj, limit) => {
  const keys = Object.keys(obj);
  if (keys && keys.length > limit) {
    keys.splice(0, keys.length - limit);
    return keys.reduce((prev, now) => {
      return Object.assign({}, prev, { [now]: obj[now] });
    }, {});
  }
  return obj;
};

export const setLocalUnreadData = convClue => {
  let data = getLocal(localKey);
  if (!data) {
    setLocal(localKey, {});
    data = getLocal(localKey);
  }
  // 限制置顶最大数量200
  data[getMarkKey()] = sliceObject(convClue, 200);

  setLocal(localKey, data);
};
